import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
  NO_ERRORS_SCHEMA,
  provideAppInitializer,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouteReuseStrategy } from "@angular/router";
import {
  createAnimation,
  IonicRouteStrategy,
  Platform,
  provideIonicAngular,
} from "@ionic/angular";
import { setAssetPath as setIonicCoreAssetPath } from "@ionic/core/components";
import { setAssetPath as setIoniconsAssetPath } from "ionicons/components";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { IonicStorageModule } from "@ionic/storage";
import { provideTranslateService, TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MqttModule } from "ngx-mqtt";
import { AccountingDetailComponent } from "src/components/general components/accounting-detail/accounting-detail.component";
import { ChooseFileComponent } from "src/components/general components/choose-file/choose-file.component";
import { GeneralComponentsModule } from "src/components/general components/general-components.module";
import { PopoverObjectInfoComponent } from "src/components/general components/popover-object-info/popover-object-info.component";
import { HelpSlideComponent } from "src/components/popup/help-slide/help-slide.component";
import { PopupModule } from "src/components/popup/popup.module";
import { environment } from "src/environments/environment";
import { AuthenticationInterceptorService } from "src/service/authentication-interceptor.service";
import { PlantService } from "src/service/plant.service";
import { AppStoreModule } from "src/state/app-store.module";
import { animationPage } from "./app-animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import {
  ngxCookiebotProvider,
} from "@halloverden/ngx-cookiebot";
import { CookiebotConfig } from "./cookiebot.config";
import { SharedComponentsModule } from "src/components/shared-components.module";
import { CodeEditorService } from "src/service/code-editor.service";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { NgxEchartsModule, provideEchartsCore } from "ngx-echarts";

export const MQTT_SERVICE_OPTIONS = {
  connectOnCreate: false,
};

@NgModule({ declarations: [
        AppComponent,
        PopoverObjectInfoComponent,
        ChooseFileComponent,
        HelpSlideComponent,
        AccountingDetailComponent,
    ],
    exports: [PopoverObjectInfoComponent, ChooseFileComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppStoreModule,
        NgxEchartsModule,
        TranslatePipe,
        TranslateDirective,
        GeneralComponentsModule,
        SharedComponentsModule,
        AppRoutingModule,
        IonicComponentsModule,
        IonicStorageModule.forRoot(environment.ionicStoreConfig),
        FormsModule,
        ReactiveFormsModule,
        MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
        NgxDatatableModule,
        //MatExpansionModule,
        PopupModule], providers: [
        // Cookiebot (web only): since ngx-cookiebot 5 the NgModule is gone, the wrapper is provided here
        ...(!environment.isApp &&
            environment.cbid &&
            environment.theme != ApplicationTheme.BLUMOTIX &&
            environment.theme != ApplicationTheme.SMART_HUB
            ? [ngxCookiebotProvider(CookiebotConfig)]
            : []),
        // Standalone build of Ionic, the one the shared-components submodule is built on: IonicModule.forRoot of
        // "@ionic/angular/lazy" must not come back, the two builds of the Ionic web components break each other.
        provideIonicAngular({
            navAnimation: animationPage,
            innerHTMLTemplatesEnabled: true,
        }),
        // An <ion-icon name="..."> is loaded from svg/<name>.svg, the folder that angular.json copies from ionicons.
        // The standalone build has no default base for that path, so it is set here, on both copies of <ion-icon>:
        // the one of ionicons (used by IonIcon) and the one inside @ionic/core (used by the Ionic components with
        // an icon, such as ion-menu-button).
        provideAppInitializer(() => {
            setIoniconsAssetPath(document.baseURI);
            setIonicCoreAssetPath(document.baseURI);
        }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: ".json" }),
        }),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptorService,
            multi: true,
        },
        PlantService,
        DatePipe,
        CodeEditorService,
        provideEchartsCore({ echarts: () => import("echarts") }),
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule { }
